<template>
  <div>
    <div class="row-width-actions-bar is-border-bottom">
      <div class="columns is-gapless">
        <div
          v-if="canDrag"
          class="column is-narrow is-border-right">
          <button class="page-header-btn is-small is-square has-cursor-grab">
            <span class="icon is-size-4"><i class="fal fa-grip-lines"></i></span>
          </button>
        </div>
        <div
          v-if="documentIsValid && (isImage || isPdf)"
          class="column is-narrow is-border-right has-background-light is-padding-small">
          <figure
            v-if="isImage"
            :style="{
              transform: 'rotate(' + rotation + 'deg)'
            }"
            @click="openPreview(item.document)"
            class="icon-container has-cursor-pointer">
            <i class="fal fa-file-image has-text-info"></i>
          </figure>
          <figure
            v-else-if="isPdf"
            :style="{
              transform: 'rotate(' + rotation + 'deg)'
            }"
            @click="openPreview(item.document)"
            class="icon-container has-cursor-pointer">
            <i class="fal fa-file-pdf has-text-danger"></i>
          </figure>
        </div>
        <div class="column is-padding-left-small is-self-centered columns is-gapless is-vcentered is-marginless">
          <div class="column is-narrow">
            <div
              class="dot is-medium has-text-white is-margin-right-small"
              :class="documentIsValid ? 'has-background-success' : 'is-white is-border is-flex'">
              <i
                v-if="documentIsValid"
                class="fal fa-check is-size-6"></i>
            </div>
          </div>
          <div class="column">
            <span v-if="!editionMode && documentIsValid && ((isAdmin && isPromoteur) || item.document.display)">
              <a
                @click="openPreview(item.document)"
                class="is-size-6 is-underline">{{ item.name }}</a>&nbsp;
              <a
                v-if="isAdmin && isPromoteur"
                @click="editionMode = true"><span class="icon"><i class="fal fa-pencil"></i></span></a>
            </span>
            <input
              v-else-if="isAdmin && isPromoteur && editionMode"
              type="text"
              @click="$event.target.select()"
              v-model="item.name"
              @input="updateName()"
              class="input is-borderless is-small is-fullwidth is-shadowless"
              placeholder="Entrer le nom du document">
            <span
              v-else
              class="is-size-6">{{ item.name }}</span>
          </div>
        </div>
        <div
          class="column is-narrow is-border-left"
          v-if="!askRemoveLink && documentIsValid && isAdmin && isPromoteur">
          <a
            v-if="!askRemoveLine"
            class="page-header-btn is-small is-square tooltip is-tooltip-top"
            data-tooltip="Supprimer document lié"
            @click="askRemove('askRemoveLink')">
            <span class="icon is-size-4"><i class="fal fa-unlink"></i></span>
          </a>
          <a
            v-else
            class="page-header-btn is-small is-square tooltip is-tooltip-top"
            data-tooltip="Supprimer document lié"
            :disabled="true">
            <span class="icon is-size-4"><i class="fal fa-unlink"></i></span>
          </a>
        </div>
        <div
          class="column is-narrow is-border-left"
          v-else-if="!askRemoveLink && !documentIsValid && isAdmin && isPromoteur">
          <a
            v-if="!askRemoveLine && !openInput"
            class="page-header-btn is-small is-square tooltip is-tooltip-top"
            @click="openModalDocumentsSelection(item.key)"
            data-tooltip="Lier un document">
            <span class="icon is-size-4"><i class="fal fa-link"></i></span>
          </a>
          <label
            v-else-if="!askRemoveLine && openInput"
            class="page-header-btn is-small is-square tooltip is-tooltip-top"
            data-tooltip="Lier un document">
            <input
              class="file-input"
              type="file"
              accept="image/*, .pdf"
              @change="processFile($event)"
              name="resume">
            <span
              v-if="!uploading"
              class="is-marginless icon is-size-4"><i class="fal fa-link"></i></span>
            <span
              v-else
              class="icon has-text-grey"><i class="fas fa-spinner fa-spin"></i></span>
          </label>
          <a
            v-else-if="askRemoveLine"
            class="page-header-btn is-small is-square tooltip is-tooltip-top"
            :disabled="true"
            data-tooltip="Lier un document">
            <span class="icon is-size-4"><i class="fal fa-link"></i></span>
          </a>
        </div>
        <div
          class="column is-narrow is-border-left"
          v-if="askRemoveLink">
          <a
            class="page-header-btn is-small is-danger is-striped"
            @click="removeLink">
            <span class="is-size-7">Confirmer suppression du document lié</span>
          </a>
        </div>
        <div
          class="column is-narrow is-border-left"
          v-if="askRemoveLink">
          <a
            class="page-header-btn is-small is-square tooltip is-tooltip-top"
            data-tooltip="Annuler suppression document lié"
            @click="cancelRemove">
            <i class="fal fa-times"></i>
          </a>
        </div>
        <div
          class="column is-narrow is-border-left"
          v-if="!askRemoveLine && !askRemoveLink && documentIsValid && (isImage || isPdf) && isAdmin && isPromoteur">
          <a
            class="page-header-btn is-small is-square tooltip is-tooltip-top"
            @click="rotateDocument"
            data-tooltip="Rotation 90° (sens inverse)">
            <span class="icon is-size-4"><i class="fal fa-undo"></i></span>
          </a>
        </div>
        <div
          class="column is-narrow is-border-left"
          v-if="!askRemoveLine && isAdmin && isPromoteur">
          <a
            v-if="!askRemoveLink"
            class="page-header-btn is-small is-square tooltip is-tooltip-top"
            @click="askRemove('askRemoveLine')"
            data-tooltip="Supprimer la ligne">
            <span class="icon is-size-4"><i class="fal fa-trash-alt"></i></span>
          </a>
          <a
            v-else
            class="page-header-btn is-small is-square tooltip is-tooltip-top"
            :disabled="true"
            data-tooltip="Supprimer la ligne">
            <span class="icon is-size-4"><i class="fal fa-trash-alt"></i></span>
          </a>
        </div>
        <div
          class="column is-narrow is-border-left"
          v-if="askRemoveLine">
          <a
            class="page-header-btn is-small is-danger is-striped"
            @click="removeLine">
            <span class="is-size-7">Confirmer suppression de la ligne</span>
          </a>
        </div>
        <div
          class="column is-narrow is-border-left"
          v-if="askRemoveLine">
          <a
            class="page-header-btn is-small is-square tooltip is-tooltip-top"
            data-tooltip="Annuler suppression de la ligne"
            @click="cancelRemove">
            <i class="fal fa-times"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Upload } from '@/mixins'
import { debounce } from 'lodash'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'DocumentListItem',
  mixins: [Upload],
  props: {
    source: {
      type: Object
    },
    allDocuments: {
      type: Object
    },
    index: {
      type: Number
    },
    canDrag: {
      type: Boolean
    },
    selectedRow: {
      type: String
    },
    openInput: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      validDocument: null,
      editionMode: false,
      uploading: false,
      askRemoveLine: false,
      askRemoveLink: false,
      rotation: 0
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isPromoteur']),
    ...mapState(['modal']),
    /**
      * return source as item
      * @returns {object}
      */
    item () {
      return this.source
    },
    /**
      * document is valide
      * @returns {boolean}
      */
    documentIsValid () {
      if (this.item.document && this.item.document.path) {
        return true
      } else {
        return false
      }
    },
    /**
      * is image
      * @returns {boolean}
      */
    isImage () {
      if (!this.item || !this.item.document || !this.item.document.path) return
      let ext = this.item.document.path.split('.')
      return /(jpg|png|jpeg|gif)/g.test(ext[ext.length - 1])
    },
    /**
      * is pdf
      * @returns {boolean}
      */
    isPdf () {
      if (!this.item || !this.item.document || !this.item.document.path) return false
      let ext = this.item.document.path.split('.')
      return ext[ext.length - 1].toLowerCase() === 'pdf'
    }
  },
  watch: {
    selectedRow (v) {
      if (v !== 'document-' + this.index) {
        this.cancelRemove()
      }
    },
    modal ({ mode, params, results }) {
      if (results) {
        if (mode === 'DOCUMENTS_SELECTION' && results.from === this.item.key) {
          // results.document.filename = this.source.name
          this.addDocumentTo(results)
        }
      }
    }
  },
  mounted () {
    // Initialiser la rotation depuis le document si elle existe
    if (this.item && this.item.document && this.item.document.rotation) {
      this.rotation = this.item.document.rotation
    }
  },
  methods: {
    /**
      * open preview document
      * @param {object} selectedDocument
      */
    openPreview (selectedDocument) {
      let params = {
        link: selectedDocument.path
      }
      this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW_SAAS', params })
    },
    /**
      * process file
      * @param {object} event
      */
    async processFile (event) {
      let file = event.target.files[0]
      this.validDocument = await this.checkAutorizedFile(file)
      if (this.validDocument === false) {
        setTimeout(() => {
          this.validDocument = null
        }, 2000)
        return
      }
      let files = new FormData()
      files.append('file[]', file, file.name)
      this.uploading = true
      let document = null
      try {
        await this.setFusToken()
        let res = await this.$fus.post({ data: files })
        document = res.data[0]
        document.fus_id = document.id
        document.display = true
        document.destination = ['display_in_adv']
      } catch (e) {
        console.log(e)
      } finally {
        this.uploading = false
      }
      if (document) {
        this.addDocumentTo(document)
      }
    },
    /**
      * add document
      * @param {object} val
      */
    addDocumentTo (val) {
      if (val.document) {
        this.$set(this.item, 'document', val.document)
        this.$set(this.item, 'name', val.document.filename)
        this.$set(this.item.document, 'destination', ['display_in_adv'])
      } else {
        this.$set(this.item, 'document', val)
        this.$set(this.item.document, 'destination', ['display_in_adv'])
        this.$set(this.item, 'name', val.filename)
      }
      this.updateItem()
    },
    /**
      * update item
      */
    updateItem () {
      this.$emit('update', this.item)
    },
    /**
      * open modal document selection
      * @param {string} from
      */
    openModalDocumentsSelection (from) {
      this.cancelRemove()
      let params = {
        title: 'Documents ADV',
        from,
        source: { ...this.allDocuments }
      }
      this.$store.commit('setModal', { mode: 'DOCUMENTS_SELECTION', params })
    },
    /**
      * remove line
      */
    removeLine () {
      this.$emit('remove', this.index)
      this.cancelRemove()
    },
    /**
      * cancel remove
      */
    cancelRemove () {
      this.askRemoveLine = false
      this.askRemoveLink = false
    },
    /**
      * remove link
      */
    removeLink () {
      this.$set(this.item, 'document', null)
      this.updateItem()
      this.cancelRemove()
    },
    /**
      * ask remove
      * @param {string} key
      */
    askRemove (key) {
      this[key] = true
      this.toggleDisplayButtons()
    },
    /**
      * update name
      */
    updateName: debounce(function () {
      this.$set(this.item.document, 'filename', this.item.name)
      this.updateItem()
    }, 500),
    /**
      * toggle display buttons
      */
    toggleDisplayButtons () {
      this.$emit('selectedRow', 'document-' + this.index)
    },
    /**
      * rotate document
      */
    rotateDocument () {
      // Décrémenter la rotation de 90° (sens inverse des aiguilles d'une montre)
      this.rotation = (this.rotation - 90 + 360) % 360
      // Sauvegarder la rotation dans le document
      this.$set(this.item.document, 'rotation', this.rotation)
      // Émettre l'événement pour notifier le parent du changement
      this.$emit('rotateDocument', { document: this.item.document, rotation: this.rotation })
    }
  }
}
</script>
<style scoped>
.image {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.pdf-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
}
</style>
